module.exports = __webpack_public_path__ + "img/MinIO-Services.3e090143.webp";